/**
 * 采购类型数据维护接口api
 */
import { msiRequest } from "../../index";
import { ResultType, delType } from "../../types";
import qs from 'qs'

//api接口枚举
enum PurchaseOrderTypeEnum {
    PurchaseOrderTypeEnum_PAGE = '/PurchaseOrderType/Page',
    PurchaseOrderTypeEnum_ADD = '/PurchaseOrderType/Add',
    PurchaseOrderTypeEnum_EDIT = '/PurchaseOrderType/Update',
    BlackOrderDetails = '/BlackWarehouse/BlackOrderDetails',
    ExecuteReport= '/BlackWarehouse/ExecuteReport',
}

export function BlackOrderDetails(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
        url: `${PurchaseOrderTypeEnum.BlackOrderDetails}?${qs.stringify(data)}`
    });
}
// ----------------------------------------------------
//采购类型 -- 列表
export function purchaseOrderType(data: any = {}) {
    return msiRequest.get<ResultType<any>>({
        url: `${PurchaseOrderTypeEnum.PurchaseOrderTypeEnum_PAGE}?${qs.stringify(data)}`
    });
}
//采购类型 -- 添加
export function purchaseOrderType_add(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: `${PurchaseOrderTypeEnum.PurchaseOrderTypeEnum_ADD}?${qs.stringify(data)}`,
        data
    })
}
//采购类型 -- 编辑
export function purchaseOrderType_edit(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: `${PurchaseOrderTypeEnum.PurchaseOrderTypeEnum_EDIT}?${qs.stringify(data)}`,
        data
    })
}

//导出
export function executeReport(data: any = {}) {
    return msiRequest.post<ResultType<any>>({
        url: `${PurchaseOrderTypeEnum.ExecuteReport}?${qs.stringify(data)}`,
         method: 'post',
        data
    })
}
















































